import {
    DataDictionaryIcon,
    DbSchemaIcon,
    SmartContractIcon,
    UploadFileIcon,
    TruncateJobIcon,
    DownloadJobIcon,
    ResetSDZDataIcon,
    WipeSDZDataIcon,
    DropChainJobIcon,
    ExportDataJobIcon,
} from '../../../../assets/images';

export interface FileData {
    name: string;
    progress: number;
    url: string;
    error: boolean;
    rejected?: boolean;
    reader?: FileReader;
}

export const replaceModalConfig = {
    title: 'Override File',
    body: 'You have already uploaded a file. If you would like to override the file you’ve already uploaded, click ‘OVERRIDE FILE’. If not, click ‘CANCEL’. ',
    primaryButtonText: 'OVERRIDE FILE',
    secondaryButtonText: 'Cancel',
    styles: {
        '& .MuiPaper-root': {
            width: '462px',
            height: '281px',
            '& .MuiDialogActions-root': {
                flexDirection: 'column-reverse',
                gap: '12px',
                padding: '16px 20px 26px 8px',
                '& .MuiButtonBase-root': {
                    fontSize: '16px',
                    padding: '8px 22px',
                },
            },
        },
    },
};

export const jobsConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'upload-data-dictionary': {
        imgSrc: DataDictionaryIcon,
        headingText: 'Import Dictionary',
        iconStyles: {
            height: '73.69px',
            width: '70px',
        },
    },
    'upload-file': {
        imgSrc: UploadFileIcon,
        headingText: 'Upload Data',
        iconStyles: {
            height: '73.69px',
            width: '70px',
        },
    },
    'upload-db-schema': {
        imgSrc: DbSchemaIcon,
        headingText: 'Import DbSchema',
        iconStyles: {
            height: '80.43px',
            width: '90px',
        },
    },
    'download-job': {
        imgSrc: DownloadJobIcon,
        headingText: 'Download Data',
        iconStyles: {
            height: '62.35px',
            width: '70px',
        },
    },
    'truncate-chain-job': {
        imgSrc: TruncateJobIcon,
        headingText: 'Truncate a Chain',
        iconStyles: {
            height: '66.02px',
            width: '75px',
        },
    },
    'execute-smart-contract-job': {
        imgSrc: SmartContractIcon,
        headingText: 'Execute Smart Contract',
        iconStyles: {
            height: '72.42px',
            width: '70px',
        },
    },
    'reset-sdz-data': {
        imgSrc: ResetSDZDataIcon,
        headingText: 'Reset SDZ',
        iconStyles: {
            height: '80px',
            width: '77.88px',
        },
    },
    'wipe-sdz-data': {
        imgSrc: WipeSDZDataIcon,
        headingText: 'Wipe SDZ Data',
        iconStyles: {
            height: '83.8px',
            width: '82px',
        },
    },
    'drop-chain': {
        imgSrc: DropChainJobIcon,
        headingText: 'Drop a Chain',
        iconStyles: {
            height: '66.02px',
            width: '75px',
        },
    },
    'export-data': {
        imgSrc: ExportDataJobIcon,
        headingText: 'Export Data',
        iconStyles: {
            height: '62.35px',
            width: '70px',
        },
    },
};
